import VueLogger from 'vuejs-logger'
import Vue from 'vue'

const isProduction = process.env.NODE_ENV === 'production'

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}

//doc https://www.npmjs.com/package/vuejs-logger

export default Vue.use(VueLogger, options)
